const initializeMenuDrawerStoreSpSubmenu = () => {
  const el = document.querySelector("#fs-menu-drawer-store-sp-submenu");
  if (!el) {
    return;
  }
  addEvents(el);
};

const addEvents = (el) => {
  el.addEventListener("show-brands", () => {
    showBrands(el);
  });
  el.addEventListener("hide-brands", () => {
    hideBrands(el);
  });
  el.addEventListener("show-collections", () => {
    showCollections(el);
  });
  el.addEventListener("hide-collections", () => {
    hideCollections(el);
  });
  el.querySelectorAll(".fs-back-button").forEach((button) => {
    button.addEventListener("click", () => {
      hideBrands(el);
      hideCollections(el);
    });
  });
  el.querySelectorAll(".fs-close-button").forEach((button) => {
    button.addEventListener("click", () => {
      const drawer = document.querySelector("#fs-menu-drawer");
      drawer.dispatchEvent(new CustomEvent("hide"));
      hideBrands(el);
      hideCollections(el);
    });
  });

  const parentItems = el.querySelectorAll(".fs-submenu-collections .fs-submenu-item.parent");
  parentItems.forEach((parentItem) => {
    parentItem.querySelector("button").addEventListener("click", (event) => {
      event.stopPropagation();
      event.preventDefault();
      parentItem.classList.toggle("open");
    });
  });
};

const showBrands = (el) => {
  const submenu = el.querySelector(".fs-sp-submenu.brands");
  submenu.style.display = "block";
  setTimeout(() => {
    submenu.classList.add("show");
    let container = el.querySelector(".fs-menu-drawer-store-sp-submenu .fs-sp-submenu");
    container.scrollTo({ top: top });
  }, 100);
};

const hideBrands = (el) => {
  const submenu = el.querySelector(".fs-sp-submenu.brands");
  submenu.classList.remove("show");
  setTimeout(() => {
    submenu.style.display = "none";
  }, 500);
};

const showCollections = (el) => {
  const submenu = el.querySelector(".fs-sp-submenu.collections");
  submenu.style.display = "block";
  setTimeout(() => {
    submenu.classList.add("show");
  }, 100);
};

const hideCollections = (el) => {
  const submenu = el.querySelector(".fs-sp-submenu.collections");
  submenu.classList.remove("show");
  setTimeout(() => {
    submenu.style.display = "none";
  }, 500);
};

/*
 * Main
 */

const menuDrawerStoreSpSubmenuMain = () => {
  initializeMenuDrawerStoreSpSubmenu();
};

addEventListener("DOMContentLoaded", (event) => {
  menuDrawerStoreSpSubmenuMain();
});
